import { Link } from "react-router-dom";

export default function PageFooter() {
  const year = new Date().getFullYear();
  return (
    <footer
      className="w-full"
      style={{
        background: "#000",
        padding: "40px 16px 40px",
        fontFamily: "'Space Grotesk', system-ui, sans-serif",
        borderTop: "1px solid rgba(255,255,255,0.08)",
      }}
    >
      <div
        className="mx-auto grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8"
        style={{ maxWidth: 1440 }}
      >
        <div>
          <div style={{ fontSize: 13, opacity: 0.55, marginBottom: 14 }}>
            Legal
          </div>
          <div style={{ fontSize: 13, opacity: 0.9, lineHeight: 1.55 }}>
            © {year} Intellivex LTD.
            <br />
            All rights reserved.
          </div>
        </div>
        <div>
          <div style={{ fontSize: 13, opacity: 0.55, marginBottom: 14 }}>
            Address
          </div>
          <div style={{ fontSize: 13, opacity: 0.9, lineHeight: 1.55 }}>
            50 Essex Street
            <br />
            London, WC2R 3JF
            <br />
            United Kingdom
          </div>
        </div>
        <div>
          <div style={{ fontSize: 13, opacity: 0.55, marginBottom: 14 }}>
            Contact
          </div>
          <div style={{ fontSize: 13, opacity: 0.9, lineHeight: 1.55 }}>
            support@inntellivex.com
            <br />
            +447520680012
          </div>
        </div>
        <div>
          <div style={{ fontSize: 13, opacity: 0.55, marginBottom: 14 }}>
            Legal
          </div>
          <div style={{ fontSize: 13, opacity: 0.9, lineHeight: 1.55 }}>
            <Link
              to="/terms-of-use"
              style={{ color: "#ECECEC", textDecoration: "underline" }}
            >
              Terms of Use
            </Link>
            <br />
            <Link
              to="/privacy-policy"
              style={{ color: "#ECECEC", textDecoration: "underline" }}
            >
              Privacy Policy
            </Link>
            <br />
            <Link
              to="/refund-policy"
              style={{ color: "#ECECEC", textDecoration: "underline" }}
            >
              Refund Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}